export const calcOptimalTotalOnColumns = ( records, posibleLabels ) => {
    const accums = Object.fromEntries(
        posibleLabels.map( key => [ `${ key }Accum`, 0.00 ] )
    );

    for( const label of posibleLabels ) {
        // console.log( 'label ', label );
        for( const record of records ){
            accums[ `${ label }Accum` ] += record[ label ];
        }
    }

    return Math.max( ...Object.values( accums ) );
}